module.exports = __webpack_public_path__ + "static/ea-2a3d632e53de32b70286869ed2cd5dae.png";